'use client';
import React, { useEffect } from 'react';
import InnerBanner from '@/src/components/common/eco/sections/inner-banner/InnerBanner.jsx';
import Banner from '@/src/components/common/eco/sections//banner/Banner';
import ContactForm from '@/src/components/common/eco/sections/contact-form/ContactForm.jsx';
import ProductList from '@/src/components/common/eco/sections/product-list/ProductList.jsx';
import Partners from '@/src/components/common/eco/sections/partners/Partners.jsx';
import CounterSectionCommon from '@/src/components/common/eco/sections/counter/CounterSectionCommon.jsx';
import ServiceList from '@/src/components/common/eco/sections/service-list/ServiceList.jsx';
import CategoryList from '@/src/components/common/eco/sections/category-list/CategoryList.jsx';
import People from '@/src/components/common/eco/sections/people/People.jsx';
import BlogList from '@/src/components/common/eco/sections/blog-list/BlogList.jsx';
import ProductListShort from '@/src/components/common/eco/sections/product-list-short/ProductListShort.jsx';
import GoogleMap from '@/src/components/common/eco/sections/google-map/GoogleMap.jsx';
import BlogListALL from '@/src/components/common/eco/sections/blog-list/BlogListALL.jsx';

const RenderedSection = ({ data, place, blogData, productData }) => {
	let sections_list = data?.sections;



	return (
		<>
			{sections_list?.length > 0 &&
				sections_list.map((item, index) => {
					switch (item?.section_data?.template) {
						case 'hero_banner':
							return <Banner data={item} key={index} />;
						case 'home_counter':
							return <CounterSectionCommon mainIndex={index} data={item} key={index} />;
						case 'home_solutions':
							return <ServiceList id={item?.section_data?.slug} data={item} key={index} />;
						case 'partner_slider':
							return <Partners version={2} mainIndex={index} data={item} key={index} />;
						case 'category_list':
							return <CategoryList version={3} data={item} key={index} mainIndex={index} />;
						case 'partners_with_box':
							return <ProductList data={item} key={index} />;
						case 'leadership_team':
							return <People version data={item} key={index} />;
						case 'blog_list':
							return <BlogList allBlog={blogData} data={item} key={index} id={'news'} />;
						case 'blog_list_all':
							return <BlogListALL allBlog={blogData} limit data={item} key={index} id={''} />;
						case 'product_list':
							return <ProductListShort allProduct={productData} award data={item} key={index} />;
						case 'inner_banner':
							return <InnerBanner  data={item} key={index} />;
						case 'contact_form':
							return <ContactForm data={item} key={index} />;
						case 'address_list':
							return <GoogleMap data={item} key={index} />;
						default:
							return null;
					}
				})}

		</>
	);
};

export default React.memo(RenderedSection);